import { useState, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  CircleMarker,
} from "react-leaflet";
import L from "leaflet";
import Modal from "react-modal";
import { X } from "lucide-react";
import img from "./logo.png"

Modal.setAppElement("#root"); // Accessibility

const defaultIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
export default function NearbyUserModal({
  isOpen,
  onRequestClose,
  radius = 1000,
  k = 5,
}) {
  const [user_location, setUserLocation] = useState(null);
  const [nearbyPlaces, setNearbyPlaces] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!isOpen) return; // Modal kapalıysa fetch yapma
    setLoading(true);
    setError(null);

    if (!navigator.geolocation) {
      setError("Tarayıcınız konum desteklemiyor");
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
  (position) => {
    const { latitude, longitude } = position.coords;
    setUserLocation({ lat: latitude, lng: longitude });

    fetch(`${API_URL}/api/nearby_user_location?lat=${latitude}&lng=${longitude}&k=${k}`)
      .then((res) => res.json())
      .then((data) => {
        setNearbyPlaces(data.nearby);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Mekanlar alınamadı");
        setLoading(false);
      });
  },
  (err) => {
    console.error(err);
    setError("Konum izni reddedildi veya alınamadı");
    setLoading(false);
  }
    );
  }, [isOpen, k]);

  // Marker listesi
  const markers = [];
const userIcon = L.divIcon({
  html: `<img src="${img}" style="width:35px;height:35px;border-radius:50%;border:2px solid white;" />`,
  className: "", // boş bırak, default class istemiyorsan
  iconSize: [45, 45],
});
  if (user_location) {
    markers.push(
      <Marker
        key="user"
        position={[user_location.lat, user_location.lng]}
        icon={userIcon}
      >
        <Popup>Sen buradasın</Popup>
      </Marker>
    );
  }

  nearbyPlaces.forEach((place, idx) => {
    markers.push(
      <CircleMarker
        key={`place-${idx}`}
        center={[place.lat, place.lng]}
        radius={10}
        color="blue"
      >
        <Popup >
          <strong>{place.ad}</strong>
          <br />
          {place.distance_m && `${Math.round(place.distance_m)} m`}
          <br />
          <a
            href={`https://www.google.com/maps/search/${encodeURIComponent(
              place.ad
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Haritalar
          </a>
        </Popup>
      </CircleMarker>
    );
  });

  const bounds = [
    ...(user_location ? [[user_location.lat, user_location.lng]] : []),
    ...nearbyPlaces.map((p) => [p.lat, p.lng]),
  ];

  return (
<Modal
  isOpen={isOpen}
  onRequestClose={onRequestClose}
  style={{
    overlay: {
      zIndex: 10000,
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      position: "relative",
      top: "auto",
      left: "auto",
      right: "auto",
      bottom: "auto",
      width: "600px",
      maxWidth: "90%",
      height: "600px",
      maxHeight: "90%",
      padding: "20px 30px",
      borderRadius: "15px",
      boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
      backgroundColor: "#f9f9f9",
      display: "flex",
      flexDirection: "column",
    },
  }}
>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
    <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#333" }}>Yakın Mekanlar</h2>
    <button 
      onClick={onRequestClose} 
      style={{
        background: "#ff5e5e",
        border: "none",
        color: "#fff",
        padding: "5px 12px",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: "bold"
      }}
    >
      Kapat
    </button>
  </div>

  {loading && <p style={{ textAlign: "center", marginTop: "50px", fontSize: "1.2rem", color: "#555" }}>Yükleniyor...</p>}
  {error && <p style={{ textAlign: "center", marginTop: "50px", fontSize: "1.2rem", color: "red" }}>{error}</p>}

  {!loading && !error && (
    <MapContainer
      bounds={bounds}
      style={{ flexGrow: 1, borderRadius: "10px" }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {markers}
    </MapContainer>
  )}
</Modal>
  );
}
